import React from 'react';

import { useTranslation } from 'react-i18next';
import LoginLayout from '../../../flows/login/components/LoginLayout';
import LoginCard from '../../../flows/login/components/LoginCard';
import Heading from '../../Heading';
import { TIMER_SCREEN_DATA } from '../../../flows/login/constants';

interface IProps {
  backButtonDestination?: string;
  shouldLogOutOnBack?: boolean
}

const TempLocked = ({ backButtonDestination, shouldLogOutOnBack }: IProps) => {
  const { LOGIN_CARD, TEXT } = TIMER_SCREEN_DATA;
  const { t } = useTranslation();
  return (
    <LoginLayout shouldLogOutOnBack={shouldLogOutOnBack} backButtonDestination={backButtonDestination} backButton backDestination={0}>
      <LoginCard className={LOGIN_CARD.CLASS_NAME} backgroundColor={LOGIN_CARD.BACKGROUND}>
        <Heading title={t('TEMPORARY_LOCKED.TITLE')} className='w-[280px] heading text-bw08 font-metricSemibold mb-4' />
        <Heading
          title={t('TEMPORARY_LOCKED.CONTENT')}
          className={TEXT.CLASS_NAME}
        />
      </LoginCard>
    </LoginLayout>
  );
};

export default TempLocked;
